
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8.833 0l.393 1.255h1.273l-1.03.802.393 1.267-1.03-.769-1.03.778.394-1.278-1.03-.8H8.44L8.833 0zm1.666 1.255h1.274L12.166 0l.393 1.255h1.274l-1.03.802.394 1.267-1.03-.769-1.031.778.394-1.278-1.03-.8zm1.343 5.82c.71-1.827-.078-2.958-.938-2.907-.786.047-1.683.992-1.916 2.705-.232.03-.465.07-.694.127-1.277.315-3.89 1.787-3.607 4.672.13 1.317 1.512 1.737 2.336 1.399.566-.232.942-.73.97-1.158 0 0-.886.206-1.196-.802-.28-.915.201-2.904 2.135-3.439a7.52 7.52 0 00.01.483c.027.503.074.896.125 1.28-.642.378-1.182.608-1.182.608l.01 1.021s.564-.289 1.278-.812c.078.664.139 1.481.12 2.85-.025 1.805-.174 2.88-.585 3.602l-.016-.007c-.647-.257-1.434-.57-1.913-.607-.71-.055-1.311.283-1.34.913-.017.366.077.786.705 1.116.654.342 1.734.366 2.848-.615.603.314 1.348.637 2.114.741 1.162.159 4.181-.516 5.038-3.987.954-3.867-1.896-6.48-4.302-7.182zm-.946-1.723c.5.063.632.79.411 1.597a7.716 7.716 0 00-1.608-.13c.234-.99.746-1.523 1.197-1.467zM9.608 8.724a6.481 6.481 0 01-.02-1.169c.51-.046.993-.01 1.44.096a3.485 3.485 0 01-.115.202c-.276.447-.755.86-1.252 1.203a3.183 3.183 0 01-.053-.332zm-1.815 8.9c-.686.42-1.35-.038-1.352-.409-.004-.505.557-.733 1.335-.387.103.046.26.137.458.253l.138.08a2.763 2.763 0 01-.58.462zm5.654-2.202c-.719 1.23-2.282 2.09-3.967 1.572.381-.47.828-1.195 1.389-2.46.813-1.835 1.113-3.332 1.113-3.332s-1.469-.207-2.105-1.51c.592-.513 1.196-1.154 1.624-1.9 1.462.543 2.469 1.904 2.69 3.705.147 1.194.076 2.521-.744 3.925z","fill":"#F0FDF4"}})])
          )
        }
      }
    